import React from "react";

import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";

import basicConfig from "./basicConfig";

function BasicForm(props) {
  const { path } = props;

  return (
    <Switch>
      {basicConfig.map(({ items }) =>
        items.map(({ path: pathItem, Form }) => (
          <Route key={pathItem} path={`${path}/${pathItem}`}>
            <Form />
          </Route>
        ))
      )}
    </Switch>
  );
}

BasicForm.propTypes = {
  path: PropTypes.string.isRequired,
};

export default React.memo(BasicForm);
